<template>
    <div>
        <p class="timeline-talks" v-html="message"></p>
        <div class="timeline-component">
            <p v-if="details.purposeOfProcessing" ><strong>Purpose of Processing : </strong>{{details.purposeOfProcessing}}</p>
            <p v-if="details.userId" ><strong> Action By : </strong>{{details.user.firstName}} {{details.user.lastName}} ({{details.user.role.title}})</p>
            <p v-else ><strong> Action By : </strong>Idenfo System</p>
            <p v-if="details.legalBasisForProcessing" ><strong>Legal Basis for Processing : </strong>{{details.legalBasisForProcessing}}</p>
            <p v-if="details.retentionPeriod" ><strong>Retention Period : </strong>{{details.retentionPeriod}}</p>
        </div>
        <div v-show="getAllFileNames" class="timeline-upload-file">
            <div class="file-section">
                <i class="icon-cloud secondary-color icon-download"></i>
            </div>
            <div class="file-attach">
                <b-button
                    class="btn btn-link"
                    variant="link"
                    @click="downloadAllFiles(getAllFileNames,'Attachments')">
                    <span class="btn-text">Download Attachment</span>
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import request from '@/utils/request'
import _ from 'lodash'
import axios from 'axios'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: ['details'],
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        message() {
            if (
                this.details.currentObj &&
                this.details.currentObj.customerData
            ) {
                if (this.details.currentObj.customerData.lastReview) {
                    return (
                        'Submitted KYC Review Status and changed KYC Status to <b>' +
                        _.startCase(
                            this.details.currentObj.customerData.lastReview
                                .status
                        ) +
                        '</b> with the following comment,<br>' +
                        this.details.currentObj.comments
                    )
                }
            }
            return 'Submitted KYC Review'
        },

        // attachment() {
        //     if (this.details && this.details.currentObj &&this.details.currentObj.document) {
        //         return this.details.currentObj.document.fileName
        //     }
        //     return ''
        // },
        getAllFileNames() {
            if (!this.details || !this.details.currentObj) return '';
            
            let currentObj = this.details.currentObj;
            let fileKeys = ['document', 'document2', 'document3'];

            let newObj = fileKeys.reduce((acc, key) => {
                if (currentObj[key] && currentObj[key].fileName) {
                    acc[key] = currentObj[key];
                }
                return acc;
            }, {});

            return Object.keys(newObj).length > 0 ? newObj : '';
        }
    },
    methods: {
        async downloadAllFiles(documents, name) {
            if (!documents || Object.keys(documents).length === 0) {
                this.$store.commit('setError', 'No Files found');
                return;
            }

            // Extract all keys that start with "document" (e.g., document, document1, document2...)
            const filesArray = Object.keys(documents)
                .filter((key) => key.startsWith('document') && documents[key] && documents[key].fileName)
                .map((key) => ({
                    src: 'customers/' + documents[key].fileName,
                    title: documents[key].originalName,
                    fileName: documents[key].fileName
                }));

            if (filesArray.length === 0) {
                this.$store.commit('setError', 'No Files found');
                return;
            }

            // Determine file extension: use the first file's extension if length is 1, else use .zip
            if(filesArray.length === 1 ){
                return this.downloadFile(filesArray[0])
            }
        
            try {
                let fileExtension = 'zip'
                let downloadableFileName = name + '_documents.' + fileExtension;
                const response = await axios.post(
                    process.env.VUE_APP_FILE_SERVICE_URL + 'download',
                    { files: filesArray },
                    { responseType: 'blob' }
                );

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', downloadableFileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (error) {
                console.error(error);
            }
        }, // End of downloadAllFiles()
        showModal(attachment) {
            this.$bvModal.show('timeline-image-preview-popup')
            this.$store.commit('setItem', attachment)
        },
        forceFileDownload(response, fileName) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', fileName) //or any other extension
            document.body.appendChild(link)
            link.click()
        }, // End of forceFileDownload() method

        async downloadFile(file) {
            let fileUrl =  file.src

            try {
                let response = await request({
                    url: `/files/${fileUrl}`,
                    responseType: 'arraybuffer',
                })
                let fileExtension = response.headers['content-type']
                if (
                    fileExtension == 'image/png' ||
                    fileExtension == 'image/jpg' ||
                    fileExtension == 'image/jpeg'
                ) {
                    this.showModal(file.fileName)
                } else {
                    this.forceFileDownload(response, file.title)
                }
            } catch (err) {
                console.log('Error occured: ', err)
            }
        },
    },
}
</script>
